module.exports = __webpack_public_path__ + "img/login.901d06f0.png";